export var WidgetEvent;
(function (WidgetEvent) {
    /** Event that occurs when the widget's view node has changed. */
    WidgetEvent["ViewNodeChanged"] = "viewNodeChange";
    /** Event that occurs when the widget's custom properties has changed. */
    WidgetEvent["PropertyChanged"] = "propertyChanged";
    /** Event that occurs when the widget size has changed. */
    WidgetEvent["Resize"] = "resize";
    /** Event that occurs when the widget position has changed. */
    WidgetEvent["Move"] = "move";
    // Mouse events
    /** Event that occurs when the widget is clicked. */
    WidgetEvent["Click"] = "click";
    /** Event that occurs when mouse movement happens in the widget. */
    WidgetEvent["MouseMove"] = "mousemove";
    /** Event that occurs when mouse pointer enters the widget. */
    WidgetEvent["MouseOver"] = "mouseover";
    /** Event that occurs when mouse pointer leaves the widget. */
    WidgetEvent["MouseOut"] = "mouseout";
    /** Event that occurs when mouse button is pressed inside the widget. */
    WidgetEvent["MouseDown"] = "mousedown";
    /** Event that occurs when mouse button is released inside the widget after mouse down. */
    WidgetEvent["MouseUp"] = "mouseup";
    // Animations
    /** Event that occurs when the widget's animation starts on the timeline. */
    WidgetEvent["AnimationStart"] = "animation_start";
    /** Event that occurs when the widget's animation ends on the timeline. */
    WidgetEvent["AnimationEnd"] = "animation_end";
    /** Event that occurs when the widget's In Transition ends on the timeline. */
    WidgetEvent["InTransitionEnd"] = "in_transition_end";
    /** Event that occurs when the widget's Out Transition starts on the timeline. */
    WidgetEvent["OutTransitionStart"] = "out_transition_start";
    /** Event that occurs when the tcdata is resolved. */
    WidgetEvent["TCData"] = "tcdata";
    /** Event that occurs when clicking show preload image */
    WidgetEvent["ShowPreloadImage"] = "show_preload_image";
})(WidgetEvent || (WidgetEvent = {}));
export var CreativeEvent;
(function (CreativeEvent) {
    // Mouse events
    /** Event that occurs when the creative is clicked. */
    CreativeEvent["Click"] = "click";
    /** Event that occurs when mouse movement happens in the creative. */
    CreativeEvent["MouseMove"] = "mousemove";
    /** Event that occurs when mouse pointer enters the creative. */
    CreativeEvent["MouseOver"] = "mouseover";
    /** Event that occurs when mouse pointer leaves the creative. */
    CreativeEvent["MouseOut"] = "mouseout";
    /** Event that occurs when mouse button is pressed inside the creative. */
    CreativeEvent["MouseDown"] = "mousedown";
    /** Event that occurs when mouse button is released inside the creative after mouse down. */
    CreativeEvent["MouseUp"] = "mouseup";
    /** Event that occurs when the creative is muted / unmuted */
    CreativeEvent["Mute"] = "mute";
})(CreativeEvent || (CreativeEvent = {}));
export var TimelineEvent;
(function (TimelineEvent) {
    /** Event that occurs when timeline starts playing. */
    TimelineEvent["Play"] = "play";
    /** Event that occurs when timeline pauses. */
    TimelineEvent["Pause"] = "pause";
    /** Event that occurs when timeline stops. */
    TimelineEvent["Stop"] = "stop";
    /** Event that occurs when timeline skips to the next loop. */
    TimelineEvent["Loop"] = "loop";
    /** Event that occurs when timeline restarts from the beginning. */
    TimelineEvent["Restart"] = "restart";
    /** Event that occurs when timeline replays from the current loop. */
    TimelineEvent["Replay"] = "replay";
    /** Event that occurs when seeking in the timeline. */
    TimelineEvent["Seek"] = "seek";
    /** Event that occurs when the timeline skips to the next loop. */
    TimelineEvent["Tick"] = "tick";
})(TimelineEvent || (TimelineEvent = {}));
